<!--
  名称：页面结尾处联系方式（解决方案定制专家）
  作者：YeMing
  时间：2021年03月17日 14:33:08
-->
<template>
  <div class="meters-container">
    <div class="meters-content"
         ref="purchase">
      <div class="content-header"
           :style="{color: purchaseSliderDown? '#fff': ''}">解决方案定制专家<div class="button"
             @click="viewPurchaseTable"><span v-if="!purchaseSliderDown">查看</span><span v-else>关闭</span></div>
      </div>
      <div class="content-main">
        <div class="content-contact">
          <div class="contact-item"><i></i><span>{{ tel }}</span></div>
          <div class="contact-item"><i></i><span>{{ email }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Meters',
  props: {
    tel: {
      type: String,
      default: "销售热线：010-58650999"
    },
    email: {
      type: String,
      default: "邮箱：public@aeronitor.com"
    }
  },
  data () {
    return {
      purchaseHeaderHeight: "",
      purchaseSliderDown: false
    };
  },
  methods: {
    viewPurchaseTable () {
      this.purchaseSliderDown = !this.purchaseSliderDown;
      if (this.purchaseSliderDown) {
        this.$refs.purchase.style.height = "auto";
        this.$refs.purchase.style.background = "#252A3B";
      } else {
        this.$refs.purchase.style.height = this.purchaseHeaderHeight;
        this.$refs.purchase.style.background = "#F5F5F5";
      }
    }
  },
  beforeDestroy () {
    this.purchaseHeaderHeight = "";
    this.purchaseSliderDown = false;
  }
};
</script>

<style lang="stylus" scoped>
.meters-container {
  .meters-content {
    height: 120px;
    margin: 0 auto;
    background: #F5F5F5;
    overflow: hidden;

    .content-header {
      width: 430px;
      height: 28px;
      line-height: 28px;
      margin: 51px auto;
      font-size: 20px;
      color: #2D70C0;
      text-align: center;
      position: relative;

      .button {
        position: absolute;
        top: 0;
        right: -80px;
        width: 72px;
        height: 28px;
        line-height: 28px;
        background: #338DFF;
        border-radius: 6px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
      }
    }

    .content-main {
      width: 1280px;
      margin: 0 auto;
      background: #677FAC;

      .content-table {
        width: 100%;

        .td-label {
          width: 300px;
        }

        td {
          line-height: 48px;
          color: #fff;
          border: 1px solid #112D62;
          padding-left: 20px;

          &:hover {
            background: #548CF6;
          }
        }
      }

      .content-contact {
        border-top: 1px solid rgba(123, 127, 179, 0.2);
        padding-top: 40px;
        background: #252A3B;

        .contact-item {
          line-height: 108px;
          background: #677FAC;
          border-radius: 4px;
          font-size: 20px;
          color: #FFFFFF;
          text-align: center;
          margin-bottom: 20px;
        }
      }
    }
  }
}

// 移动端
@media all and (min-width: 320px) and (max-width: 768px) {
  .meters-container {
    .meters-content {
      .content-header {
        width: 100%;

        .button {
          right: 20px;
        }
      }

      .content-main {
        width: 100%;

        .content-table {
          .td-lable {
            width: 100px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/meters/index.vue